//componentes
//import { DetalleComponent } from './detalle/detalle.component';
//import {ReporteComodatosClienteComponent} from './reporte-comodatos-cliente/reporte-comodatos-cliente.component'
//import { DirectorioComponent } from './directorio/directorio.component';
//import { HomeComponent } from './home/home.component';
//import { BusquedaComponent } from './busqueda/busqueda.component';

//import { ObjmixnComponent } from './objmixn/objmixn.component';
//import { ObjmixGteSucursalComponent } from './objmix-gte-sucursal/objmix-gte-sucursal.component';
//import { ObjmixdivisionalComponent } from './objmixdivisional/objmixdivisional.component';
//import { ObjmixsucursalComponent } from './objmixsucursal/objmixsucursal.component';
//import { ObjmixGteDivisionalComponent } from './objmix-gte-divisional/objmix-gte-divisional.component';
//import { ObjmixNacionalComponent } from './objmix-nacional/objmix-nacional.component';
//import { ObjmixagenteComponent } from './objmixagente/objmixagente.component';



//import { LoginnComponent } from './loginn/loginn.component';
//import { ScordcardgsComponent } from './scordcardgs/scordcardgs.component';
//import { ReportevtaobjcteComponent } from './reportevtaobjcte/reportevtaobjcte.component';


//import { RetoTorkBitacoraSeguimientoComponent } from './reto-tork-bitacora-seguimiento/reto-tork-bitacora-seguimiento.component';
//import { RetoTorkListaDespachadoresComponent } from './reto-tork-lista-despachadores/reto-tork-lista-despachadores.component';
//import { PoconexionComponent } from './poconexion/poconexion.component';
//import { AutpreciominComponent } from './autpreciomin/autpreciomin.component';

//import { VtexComponent } from './vtex/vtex.component';
//import {InventariosComponent} from './inventarios/inventarios.component';
//import {ComodatosproComponent} from './comodatospro/comodatospro.component';
//import {DetallescomodaproComponent} from './detallescomodapro/detallescomodapro.component';
//import {CapturadorComponent} from './capturador/capturador.component';
// import { ConfigMercadosComponent } from './config-mercados/config-mercados.component';
//import { PedidosVentasComponent } from './pedidos-ventas/pedidos-ventas.component';
//import { LeadsCarteraComponent } from './leads-cartera/leads-cartera.component';
// import { LeadsFamiliasComponent } from './leads-familias/leads-familias.component';

//import {CotizacionesComponent } from './cotizaciones/cotizaciones.component';
//import {AromiaComponent} from './aromia/aromia.component'
//import { InsertarComodatosComponent } from './comodatos/comodatos.component';

//import {ListadoComodatosComponent}from './listado-comodatos/listado-comodatos.component'
//import {ReportePrincipalComponent}from './reporte-principal/reporte-principal.component'

//import {CarroComodatosComponent} from './carro-comodatos/carro-comodatos.component'
// import {EcodeliPremiaComponent } from './ecodeli-premia/ecodeli-premia.component';
//import { LeadComponent } from './lead/lead.component';
//import { ProspectoComponent } from './prospecto/prospecto.component';
//import {PlantillasComponent}from './plantillas/plantillas.component';
//import {PoliticaComponent} from './politica/politica.component'
//import { SolicitudesFamiliasComponent } from './solicitudes-familias/solicitudes-familias.component';
// import { DetalleLeadsComponent } from './detalle-leads/detalle-leads.component';
//import {  ComodatosClienteComponent} from './comodatos-cliente/comodatos-cliente.component';
// import { DetalleFamiliaComponent } from './detalle-familia/detalle-familia.component';
//import { TableroLeadsOportunidadesComponent } from './tablero-leads-oportunidades/tablero-leads-oportunidades.component';
//no se usa import { PruebasComponent } from './pruebas/pruebas.component';

//import { DetalleOportunidadComponent } from './detalle-oportunidad/detalle-oportunidad.component';
// import { DetalleFamiliaClienteComponent } from './detalle-familia-cliente/detalle-familia-cliente.component';
//import { DetalleFamiliaSucursalComponent } from './detalle-familia-sucursal/detalle-familia-sucursal.component';
//import { SolicitudAltaClienteComponent } from './solicitud-alta-cliente/solicitud-alta-cliente.component';
/* import {ObjMixComponent} from './obj-mix/obj-mix.component'; */
//import { RelojchecadorComponent } from './relojchecador/relojchecador.component';
//import { VentasNetasComponent } from './ventas-netas/ventas-netas.component';
//import {VentasDetalleComponent} from './ventas-detalle/ventas-detalle.component';
//import {ReporteFactvsDevolucionesComponent} from './reporte-factvs-devoluciones/reporte-factvs-devoluciones.component';
//import {ScoreCardComponent} from './score-card/score-card.component';
//import {UsuariosComercialComponent}from './usuarios-comercial/usuarios-comercial.component';

//import {ListRemisionesComponent} from './list-remisiones/list-remisiones.component';
//import {ListadoComplementoPagoComponent} from './listado-complemento-pago/listado-complemento-pago.component';
//import {ListadoEvidenciasComodatosComponent} from './listado-evidencias-comodatos/listado-evidencias-comodatos.component';
//import {ListadoReporteEmbarquesComponent} from './listado-reporte-embarques/listado-reporte-embarques.component';
//import { DetalleArticuloComponent } from './detalle-articulo/detalle-articulo.component';

//import { CotizadorArticulosComponent } from './cotizador-articulos/cotizador-articulos.component';
//import { CotizadorLineaComponent } from './cotizador-linea/cotizador-linea.component';
//import { CotizadorSubLineaComponent } from './cotizador-sub-linea/cotizador-sub-linea.component';


//import { CatalogoComponent } from './catalogo/catalogo.component';
//import { ComprasindirectasComponent } from './comprasindirectas/comprasindirectas.component';
//import { SolicitudpresupuestosComponent } from './solicitudpresupuestos/solicitudpresupuestos.component';
//import { ComodatoDetalleComponent } from './comodato-detalle/comodato-detalle.component';
//import {ComodatosLineasComponent} from './comodatos-lineas/comodatos-lineas.component';
// import {ComodatosArticulosComponent} from './comodatos-articulos/comodatos-articulos.component'
//import { PedidosPendientesComponent } from './pedidos-pendientes/pedidos-pendientes.component';
//import { RemisionesPendientesComponent } from './remisiones-pendientes/remisiones-pendientes.component';
// import {ReporteAvanceGerenteComponent } from './reporte-avance-gerente/reporte-avance-gerente.component';
//import { CostosDetalleArticuloComponent } from './costos-detalle-articulo/costos-detalle-articulo.component';
//import {ReporteVentadiariaComponent } from './reporte-ventadiaria/reporte-ventadiaria.component';

//import {ClientesFaltantesComponent} from './clientes-faltantes/clientes-faltantes.component';

//import { MinutaLeadComponent } from './minuta-lead/minuta-lead.component';
/* Componentes cliente */
/* import {ClienteReportePrincipalNewComponent} from './cliente-reporte-principal-new/cliente-reporte-principal-new.component'
import {ClienteReportePrincipalComponent}from './cliente-reporte-principal/cliente-reporte-principal.component';
import {ClientePreciosEspecialesComponent}from './cliente-precios-especiales/cliente-precios-especiales.component';
import {ClienteFacturasComponent}from './cliente-facturas/cliente-facturas.component';
import { EstadoCuentaComponent} from './estado-cuenta/estado-cuenta.component';
import {DatosFiscalesCteComponent} from './datos-fiscales-cte/datos-fiscales-cte.component'
import{ClienteSucursalesComponent} from  './cliente-sucursales/cliente-sucursales.component' 
import {ClienteComplementopagoComponent}from './cliente-complementopago/cliente-complementopago.component';
import {ClienteSolicitudPedidoComponent}from './cliente-solicitud-pedido/cliente-solicitud-pedido.component';
import {ClienteSeguimientoPedidosComponent}from './cliente-seguimiento-pedidos/cliente-seguimiento-pedidos.component';
import {ClienteRutaPedidosComponent}from './cliente-ruta-pedidos/cliente-ruta-pedidos.component';
import {ClienteVentaArticuloComponent} from'./cliente-venta-articulo/cliente-venta-articulo.component'
import {ClienteVentaLineaComponent}from './cliente-venta-linea/cliente-venta-linea.component';
import {ClientePresupuestoSucursalComponent} from './cliente-presupuesto-sucursal/cliente-presupuesto-sucursal.component';
import {ClienteVentaMontoComponent}from './cliente-venta-monto/cliente-venta-monto.component';
*/


//import {ConcursoInscripcionComponent}from './concurso-inscripcion/concurso-inscripcion.component';
/**PLANEADOR**/
//import {PlaneadorTraspasosNacionalComponent} from './planeador-traspasos-nacional/planeador-traspasos-nacional.component'
//import {PlaneadorCapacidadAlamacenComponent}from './planeador-capacidad-alamacen/planeador-capacidad-alamacen.component';
//import {PlaneadorLogisticaComponent} from './planeador-logistica/planeador-logistica.component';
//import {TransitosComponent} from './transitos/transitos.component';
//import {PlaneadorClavesSustitutasComponent} from './planeador-claves-sustitutas/planeador-claves-sustitutas.component';
//import {PlaneadorComprasComponent} from './planeador-compras/planeador-compras.component'
//import {PlaneadorComprasExcedenteComponent} from './planeador-compras-excedente/planeador-compras-excedente.component'
//import {TransitosComprasComponent} from './transitos-compras/transitos-compras.component';
//import { TransitosGeneradosComponent } from './transitos-generados/transitos-generados.component';
//import { TransitosIndicadoresComponent}from './transitos-indicadores/transitos-indicadores.component';
//import { TransitosGeneradosEncabezadoComponent} from './transitos-generados-encabezado/transitos-generados-encabezado.component'
/* FIN PLANEADOR */
/***ecodeli partner ****/
//import {PartnerFinpedidoComponent}from './partner-finpedido/partner-finpedido.component'
//import {PartnerFinpedidoTransferenciaComponent}from './partner-finpedido-transferencia/partner-finpedido-transferencia.component'
//import {PartnerErrorCompraComponent} from './partner-error-compra/partner-error-compra.component'
//import {PartnerPrincipalComponent}from './partner-principal/partner-principal.component';
//import {PartnerBeneficiosComponent}from './partner-beneficios/partner-beneficios.component'; 
//import {PartnerRecompensasComponent}from './partner-recompensas/partner-recompensas.component';
//import {PartnerRegistroComponent}from './partner-registro/partner-registro.component';
//import {PartnerCarritoComponent}from './partner-carrito/partner-carrito.component';
//import {PartnerPasarelaComponent}from './partner-pasarela/partner-pasarela.component';
//import {PartnerMispedidosComponent}from './partner-mispedidos/partner-mispedidos.component';
//import {PartnerOfertaMesComponent} from './partner-oferta-mes/partner-oferta-mes.component'; 
//import {PartnerClientesComponent} from './partner-clientes/partner-clientes.component';
//import { PartnerDetalleDescuentosComponent} from './partner-detalle-descuentos/partner-detalle-descuentos.component';
//import {CotizadorPartnerComponent}from './cotizador-partner/cotizador-partner.component';
//import { PartnerDescuentosComponent } from './partner-descuentos/partner-descuentos.component';   
// import {PartnerHomeComponent} from './partner-home/partner-home.component';
//import {PartnerMicuentaComponent} from './partner-micuenta/partner-micuenta.component';
//import { SearchProspectacionComponent } from './search-prospectacion/search-prospectacion.component';
//import {PartnerOfertasComponent}from './partner-ofertas/partner-ofertas.component';
/* import { EcommercePedidosComponent } from './ecommerce-pedidos/ecommerce-pedidos.component';
import {AdminCuponesComponent} from './admin-cupones/admin-cupones.component';
import {EcommerceAdminArtComponent} from './ecommerce-admin-art/ecommerce-admin-art.component';
import { PartnerAdminDescuentosComponent} from './partner-admin-descuentos/partner-admin-descuentos.component';
import { UsuariosPartnerComponent } from './usuarios-partner/usuarios-partner.component';
import { EcommerceBannersAdminComponent} from './ecommerce-banners-admin/ecommerce-banners-admin.component';
import {PartnerPedidosComponent}from './partner-pedidos/partner-pedidos.component';
import {ArticuloTresMComponent} from './articulo-tres-m/articulo-tres-m.component' */

//import { PedidosCastoresComponent} from './pedidos-castores/pedidos-castores.component'
/**fin ecodeli partner ***/

/**lazy routes */
//import { RetoTorkComponent } from './reto-tork/reto-tork.component';
//import { RetoTorkBitacoraInicialComponent } from './reto-tork-bitacora-inicial/reto-tork-bitacora-inicial.component';

/* import { PartnerConfirmacionContrasenaComponent } from './partner-confirmacion-contrasena/partner-confirmacion-contrasena.component'
import { PartnerNuevaContrasenaComponent } from './partner-nueva-contrasena/partner-nueva-contrasena.component'
import { PartnerSolicitudContrasenaComponent } from './partner-solicitud-contrasena/partner-solicitud-contrasena.component'
import { LoginPartnerComponent } from './login-partner/login-partner.component'
import { PartnerInfoComponent } from './partner-info/partner-info.component'; */

//import { ReportecomodatosComponent } from './reportecomodatos/reportecomodatos.component';
//import { CotizadornewComponent } from './cotizadornew/cotizadornew.component';
//import { CarritoresumenComponent } from './carritoresumen/carritoresumen.component';
//import { AltaclienteComponent } from './altacliente/altacliente.component';
//import { ListadoComodatosTodosComponent } from './listado-comodatos-todos/listado-comodatos-todos.component'
//import { InventariosEcodeliComponent } from './inventarios-ecodeli/inventarios-ecodeli.component';
//import { PedidosEcodeliComponent } from './pedidos-ecodeli/pedidos-ecodeli.component';
//import { PasarelaPagoComponent } from './pasarela-pago/pasarela-pago.component';
//import { CotizadorComponent } from './cotizador/cotizador.component';
 //import { DashboardVendedorComponent } from './dashboard-vendedor/dashboard-vendedor.component';
//import { SolicitudActualizacionCreditoComponent } from './solicitud-actualizacion-credito/solicitud-actualizacion-credito.component';
//import { ActualizacionDatosGeneralesComponent } from './actualizacion-datos-generales/actualizacion-datos-generales.component';
//import { VacantesComponent } from './vacantes/vacantes.component';
//import { PlantillaFiltrosComponent } from './plantilla-filtros/plantilla-filtros.component';
//import { VentaConsignaComponent } from './venta-consigna/venta-consigna.component';
//import { DetallePedidosPComponent } from './detalle-pedidos-p/detalle-pedidos-p.component';
//import { CancelarPedidoComponent } from './cancelar-pedido/cancelar-pedido.component'
//import { EcommerceProductoComponent } from './ecommerce-producto/ecommerce-producto.component';
/* import { EcommerceCarritoComponent } from './ecommerce-carrito/ecommerce-carrito.component';
import { EcommerceAyudaComponent } from './ecommerce-ayuda/ecommerce-ayuda.component';
import { EcommerceLoginComponent } from './ecommerce-login/ecommerce-login.component';
//import { EcommerceRegisterComponent } from './ecommerce-register/ecommerce-register.component'; */
//import { EcommerceUserDireccionComponent } from './ecommerce-user-direccion/ecommerce-user-direccion.component';
//import { EcommerceUserInicioComponent } from './ecommerce-user-inicio/ecommerce-user-inicio.component';
//import { EcommercePedidosCteComponent } from './ecommerce-pedidos-cte/ecommerce-pedidos-cte.component';
//import { EcommerceRastrearPedidoComponent } from './ecommerce-rastrear-pedido/ecommerce-rastrear-pedido.component';
//import { EcommerceFacturaDataComponent } from './ecommerce-factura-data/ecommerce-factura-data.component';
//import { EcommercePerfilComponent } from './ecommerce-perfil/ecommerce-perfil.component';

//import { EcommercePrivacidadComponent } from './ecommerce-privacidad/ecommerce-privacidad.component';
// import { EcommerceTerminoenvioComponent } from './ecommerce-terminoenvio/ecommerce-terminoenvio.component';

//import { BannerArtComponent } from './banner-art/banner-art.component';
//import { ClienteDetallePedidoComponent } from './cliente-detalle-pedido/cliente-detalle-pedido.component'
//import { EcommerceFinpedidoComponent } from './ecommerce-finpedido/ecommerce-finpedido.component';
//import { PagoErrorComponent } from './pago-error/pago-error.component';
//import { CambioDomicilioFiscalComponent } from './cambio-domicilio-fiscal/cambio-domicilio-fiscal.component';
//import { ClienteReporteExcedidosComponent } from './cliente-reporte-excedidos/cliente-reporte-excedidos.component';
//import { AltaSucursalClienteComponent } from './alta-sucursal-cliente/alta-sucursal-cliente.component';
//import { DetalleContactoComponent } from './detalle-contacto/detalle-contacto.component';
//import { DetalleRemisionComponent } from './detalle-remision/detalle-remision.component';
//import { ConvenioFamiliaComponent } from './convenio-familia/convenio-familia.component';

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
//import { LoginComponent } from './login/login.component';
// import { AltaReglaNegocioComponent } from './alta-regla-negocio/alta-regla-negocio.component';
//import { SolicitudIvaFronterizoComponent } from './solicitud-iva-fronterizo/solicitud-iva-fronterizo.component';
 import { EcommerceComponent } from './ecommerce/ecommerce.component';
//import { EcommerceDetalleCategoriaComponent } from './ecommerce-detalle-categoria/ecommerce-detalle-categoria.component'
//import { EcommerceDetalleArtCategoriaComponent } from './ecommerce-detalle-art-categoria/ecommerce-detalle-art-categoria.component'
//import { EcommerceDetallearticuloComponent } from './ecommerce-detallearticulo/ecommerce-detallearticulo.component';
//import { EcommerceNewComponent } from './ecommerce-new/ecommerce-new.component'


const routes: Routes = [

  //{ path: 'alta_reglaNegocio', component: AltaReglaNegocioComponent },
 // { path: 'iva_fronterizo', component: SolicitudIvaFronterizoComponent },
 
  
 //nueva imagen de ecommerce { path: 'ecom', component: EcommerceNewComponent },
 

 // { path: 'error-pago', component: PagoErrorComponent },
  { path: 'tienda', component: EcommerceComponent },
  //{ path: 'tienda/:categoria', component: EcommerceDetalleCategoriaComponent },
  //{ path: 'tienda/:categoria/:grupo', component: EcommerceDetalleArtCategoriaComponent },
  //{ path: 'tienda/:categoria/:grupo/:productoNombre', component: EcommerceDetallearticuloComponent },
  
  //{ path: 'login', component: LoginComponent },
  
  // { path: 'tienda', component: EcommerceComponent },
  { path: 'retoTork', loadChildren: () => import('./reto-tork/reto-tork.module').then(m => m.RetoTorkModule) },
  { path: 'objetivos-mix', loadChildren: () => import('./obj-mix/obj-mix.module').then(m => m.ObjMixModule) },  

  { path: 'reportePrincipal', loadChildren: () => import('./reporte-principal/reportes.module').then(m => m.ReportesModule) },
  { path: 'ecommerce', loadChildren: () => import('./ecommerce-pedidos/ecommerce-pedidos.module').then(m => m.EcommercePedidosModule) },
  { path: 'planeador', loadChildren: () => import('./planeador-logistica/planeador-logistica.module').then(m => m.PlaneadorLogisticaModule) },
  { path: 'productos', loadChildren: () => import('./cotizador-linea/ventas.module').then(m => m.VentasModule) },
  { path: 'cliente', loadChildren: () => import('./cliente-reporte-principal-new/cliente.module').then(m => m.ClienteModule) },
  { path: 'partner', loadChildren: () => import('./partner-micuenta/partner.module').then(m => m.PartnerModule) },
  { path: 'leads', loadChildren: () => import('./lead/leads.module').then(m => m.LeadsModule) },
  { path: 'dashboard', loadChildren: () => import('./dashboard-vendedor/dashboard.module').then(m => m.DashboardModule) }, 
  { path: 'tiendaproducto', loadChildren: () => import('./ecommerce-producto/tienda.module').then(m => m.TiendaModule) }, 
  { path: 'altaCliente', loadChildren: () => import('./altacliente/cliente.module').then(m => m.ClienteModule) }, 
 // { path: 'tienda', loadChildren: () => import('./ecommerce/tienda-principal.module').then(m => m.TiendaPrincipalModule) }, 
  { path: 'tienda/:categoria', loadChildren: () => import('./ecommerce-detalle-categoria/ecommerce-det-categoria.module').then(m => m.DetCategoriaModule) }, 
  { path: 'tienda/:categoria/:grupo', loadChildren: () => import('./ecommerce-detalle-art-categoria/ecommerce-categoria.module').then(m => m.ECategoriaArtModule) }, 
  { path: 'tienda/:categoria/:grupo/:productoNombre', loadChildren: () => import('./ecommerce-detallearticulo/ecoomerce-art.module').then(m => m.EDetalleArtModule) },
  //{ path: '**', loadChildren: () => import('./ecommerce/tienda-principal.module').then(m => m.TiendaPrincipalModule) }, 
   { path: '**', component: EcommerceComponent },//modificar aqui el componente con el que inicia la carga LoginComponent
  
 // { path: 'convenio_familia', component: ConvenioFamiliaComponent },
  //AL PARECER NO SE USA { path: 'detalle_remision', component: DetalleRemisionComponent },
  //{ path: 'detalle_contacto', component: DetalleContactoComponent },
 // { path: 'alta_sucursalCliente', component: AltaSucursalClienteComponent },
 // { path: 'cliente_unidades_excedidas', component: ClienteReporteExcedidosComponent },
  //{ path: 'cambio_domicilioFiscal', component: CambioDomicilioFiscalComponent },
  //  { path: 'confirma-pedido_mp', component: EcommerceFinpedidoComponent },
  // { path: 'reporteVentaDiaria', component: ReporteVentadiariaComponent },
  //{ path: 'costosDetalleArt', component: CostosDetalleArticuloComponent },
  // { path: 'ReporteAvanceMensual', component: ReporteAvanceGerenteComponent },
  //{ path: 'comodatoDetalle', component: ComodatoDetalleComponent },
  //al parecer no se usa { path: 'solicitudpresupuestos', component: SolicitudpresupuestosComponent },
  //al parecer no se usa { path: 'comprasindirectas', component: ComprasindirectasComponent },
  // original { path: 'cotizador_Articulos', component: CotizadorArticulosComponent },
  // { path: 'cotizador_SubLinea', component:CotizadorSubLineaComponent  },
  /*  {path: 'objMixAdd', component: ObjMixComponent}, */
  //{ path: 'objmixAgt', component: ObjmixagenteComponent },
  //{ path: 'objmixNacional', component: ObjmixNacionalComponent },
  // { path: 'objmixD', component: ObjmixdivisionalComponent},
  //{ path: 'objmixS', component: ObjmixsucursalComponent},
  //{ path: 'objmixGteDivisional', component: ObjmixGteDivisionalComponent },
  //{ path: 'objmixGteSucursal', component: ObjmixGteSucursalComponent },
  //revisar si se usa  { path: 'detalle/:parametro', component: DetalleComponent },
  //revisar si se usa { path: 'detalle', component: DetalleComponent },
  //ya no se usa { path: 'objmixN', component: ObjmixnComponent }, 
  // { path: 'Reporte_ScoreCard', component: ScoreCardComponent },
  //{ path: 'Facturas_Devoluciones', component: ReporteFactvsDevolucionesComponent },
  //{ path: 'SolicitudAltaCte', component: SolicitudAltaClienteComponent },
  //no se para que sirve { path: 'po', component: PoconexionComponent },
  //{ path: 'home', component: HomeComponent },
  // no se usa{ path: 'busqueda', component: BusquedaComponent },
  //{ path: 'directorio', component: DirectorioComponent },
  //{ path: 'objmixSG', component: ObjmixgsComponent},
  // { path: 'familias', component: FamiliasComponent},
  //  { path: 'reportevtaobj', component: ReportevtaobjcteComponent},
  //{ path: 'retoTorkSeguimiento', component: RetoTorkBitacoraSeguimientoComponent  },
  //{ path: 'listaDespachadores', component: RetoTorkListaDespachadoresComponent },
  //{ path: 'inventarios', component: InventariosComponent},
  //{ path: 'cotizaciones',component:CotizacionesComponent},
 // { path: 'leadsCartera', component: LeadsCarteraComponent },
  //{ path: 'vtex', component: VtexComponent },
  //{ path: 'Aromia', component: AromiaComponent },
  //{ path: 'detallesComodatosProgramador',component: DetallescomodaproComponent, pathMatch: 'full'},
  // era de nfc { path: 'comodatosprogram', component: ComodatosproComponent } , 
  //{ path: 'capturadorPedidos', component: CapturadorComponent } , 
  //{ path: 'ConfiguraciondeMercados',component: ConfigMercadosComponent},
  //antigup { path: 'comodatos',component: InsertarComodatosComponent },
  //{ path: 'listadoComodatos',component:ListadoComodatosComponent},
  //  { path: 'reportePrincipal',component:ReportePrincipalComponent},
  //{ path: 'leads', component: LeadComponent },
  //{ path: 'prospectos', component: ProspectoComponent },
  // {path: 'EcodeliPremia',component:EcodeliPremiaComponent},
  //{ path: 'carcmv2',component:CarroComodatosComponent},
  //{ path: 'lstPlantillas',component:PlantillasComponent},
  //{ path: 'leadsFamilias', component: LeadsFamiliasComponent },
  //{path: 'comodatosPorCliente',component:ComodatosClienteComponent},
 // { path: 'detalleLead', component: DetalleLeadsComponent },
 // { path: 'detalleLeadFamilia', component: DetalleFamiliaComponent },/* /:intID_Leads/:intID_Familia/:strFamilia */
  //{ path: 'tableroLeads', component: TableroLeadsOportunidadesComponent },
  //{ path: 'detalleLeadCliente', component: DetalleFamiliaClienteComponent },
  //{ path: 'detalleLeadSucursal', component: DetalleFamiliaSucursalComponent },
   // { path: 'RelojChecador', component: RelojchecadorComponent },
  //{ path: 'scordcardgs', component: ScordcardgsComponent },
  //al parecer no se usa{ path: 'AutPrecioMinimo', component: AutpreciominComponent },
  //al parecer no se usa{ path: 'pedidosVentas', component: PedidosVentasComponent },
   //{ path: 'PruebasApis', component: LoginnComponent },
  //{ path: 'solicitudes_familias', component: SolicitudesFamiliasComponent },
   // { path: 'detoport', component: DetalleOportunidadComponent },
  //{ path: 'pruebas', component: PruebasComponent },
  // {path: 'ventasNetas', component: VentasNetasComponent},
  //{path: 'ventasDetalle', component: VentasDetalleComponent},
  //{path: 'listadoRemisiones',component:ListRemisionesComponent},  
  //{path: 'listadoComplementoPago',component:ListadoComplementoPagoComponent},
  //{path: 'listadoEvidenciaComodatos',component:ListadoEvidenciasComodatosComponent},
  //{path: 'listadoEmbarques',component:ListadoReporteEmbarquesComponent},
  //{path: 'detalle_articulo',component:DetalleArticuloComponent}, 
  //{path: 'pedidos-castores', component:PedidosCastoresComponent},
  // {path: 'comodatos_lineas',component:ComodatosLineasComponent},
  //{path: 'comodatos_articulos',component:ComodatosArticulosComponent},
  //ya no se usara {path: 'catalogo',component:CatalogoComponent},
  // {path: 'pedidos_pendientes',component:PedidosPendientesComponent},  
  //{path: 'clientes_faltantes',component:ClientesFaltantesComponent},  
  //{path: 'reporte-comodatos-cliente',component:ReporteComodatosClienteComponent}, 
  //{path: 'usuariosComercaial',component:UsuariosComercialComponent},
  /*  
   {path: 'admin-cupones', component:AdminCuponesComponent},
   {path: 'tienda-pedidos',component:EcommercePedidosComponent},
   {path: 'admin-destacados-nuevos',component:EcommerceAdminArtComponent},
   {path: 'administrar-banners',component:EcommerceBannersAdminComponent},
   {path: 'usuarios-partner',component:UsuariosPartnerComponent},
   {path: 'partner-admin-descuentos',component:PartnerAdminDescuentosComponent},
   {path: 'partner-pedidos', component:PartnerPedidosComponent}, 
   {path: 'articulos-3m', component:ArticuloTresMComponent}, */
  //{path: 'tienda-categoria', component:EcommerceDetalleCategoriaComponent},
  //{path: 'tienda-sub-categoria', component:EcommerceDetalleArtCategoriaComponent}, 
  //{path: 'tienda-art', component: EcommerceDetallearticuloComponent },
  //{ path: 'remisiones_pendientes', component: RemisionesPendientesComponent },
  //{ path: 'Vacantes', component: VacantesComponent },
//  { path: 'detalle-pedido-cliente', component: ClienteDetallePedidoComponent },
  //{ path: 'altaCliente', component: AltaclienteComponent },
  // revisar si se usa { path: 'reportecomodatos', component: ReportecomodatosComponent }, 
  //no sirve{ path: 'Cotizador', component: CotizadornewComponent },
  //{ path: 'carritoresumen', component: CarritoresumenComponent },
  //creo que no se usa { path: 'pedidosEcodeli', component: PedidosEcodeliComponent },
 //creo que no se usa { path: 'inventariosEcodeli', component: InventariosEcodeliComponent },
  //{ path: 'dashboard', component: DashboardVendedorComponent },
  //{ path: 'pasarela', component: PasarelaPagoComponent },
  //no sirve{ path: 'cotizadorPrueba', component: CotizadorComponent },
  //{ path: 'listadoComodatosTodos', component: ListadoComodatosTodosComponent },
  //no se usa{ path: 'solicitud_actualizacionCredito', component: SolicitudActualizacionCreditoComponent },
  //al parecer no se usa{ path: 'actualizacion_datosGenerales', component: ActualizacionDatosGeneralesComponent },
  //{ path: 'venta_consigna', component: VentaConsignaComponent },
  //{ path: 'detalle_pedido', component: DetallePedidosPComponent },
 //{ path: 'cancelar_pedido', component: CancelarPedidoComponent },
 //ejemplo de los filtros { path: 'plantillaFiltros', component: PlantillaFiltrosComponent },
  // { path: 'minuta', component: MinutaLeadComponent },
 // { path: 'tiendaproducto', component: EcommerceProductoComponent }, //debe cargar al inicio
      //  { path: 'especiales/:bannerNombre', component: BannerArtComponent },
  //{ path: 'declaracion-privacidad', component: EcommercePrivacidadComponent },
  //{path: 'concurso-inscripcion', component:ConcursoInscripcionComponent},
    /* { path: 'tienda-carrito', component: EcommerceCarritoComponent },
  { path: 'ayuda', component: EcommerceAyudaComponent },
  { path: 'tlogin', component: EcommerceLoginComponent },
  { path: 'register', component: EcommerceRegisterComponent }, */
/*      { path: 'facturaCte', component: EcommerceFacturaDataComponent },
  { path: 'editdireccion', component: EcommerceUserDireccionComponent }, */
  //no se usa{ path: 'tHome', component: EcommerceUserInicioComponent },
  //{ path: 'mispedidos', component: EcommercePedidosCteComponent },
  //{ path: 'seguimientop', component: EcommerceRastrearPedidoComponent },

  //{ path: 'perfilCte', component: EcommercePerfilComponent },
  //{ path: 'terminos-envio-servicio', component: EcommerceTerminoenvioComponent },
 
  //{ path: 'login-partner', component: LoginPartnerComponent },
  //{ path: 'partner-info', component: PartnerInfoComponent },
  //{ path: 'partner-solicitud-contrasena', component: PartnerSolicitudContrasenaComponent },
  //{ path: 'partner-codigo', component: PartnerConfirmacionContrasenaComponent },
  //{ path: 'partner-nueva-contrasena', component: PartnerNuevaContrasenaComponent },

  //{path: 'politica', component:PoliticaComponent},
  ////////////////////////CLIENTE/////////////////////
  /*
    {path: 'cliente-reporte-nuevo', component:ClienteReportePrincipalNewComponent},
    {path: 'tablerocliente', component:ClienteReportePrincipalComponent},
    {path: 'precios-especiales', component:ClientePreciosEspecialesComponent}, 
    {path: 'cliente-factura', component:ClienteFacturasComponent},
    {path: 'estado-cuenta-cte',component:EstadoCuentaComponent},
    {path: 'datos-fiscales-cte',component:DatosFiscalesCteComponent},
    {path: 'sucursales-cliente',component:ClienteSucursalesComponent},
    {path: 'cliente-complemento-pago',component:ClienteComplementopagoComponent},
    {path: 'listado-solicitud-cliente',component:ClienteSolicitudPedidoComponent},
    {path: 'cliente-seguimiento-pedido',component:ClienteSeguimientoPedidosComponent}, 
    {path: 'cliente-ruta-pedido',component:ClienteRutaPedidosComponent},
    {path: 'venta-articulo', component:ClienteVentaArticuloComponent},
    {path: 'cliente-venta-linea',component:ClienteVentaLineaComponent},
    {path: 'cliente-presupuesto-sucursal', component:ClientePresupuestoSucursalComponent}, 
    {path: 'cliente-monto',component:ClienteVentaMontoComponent},
    */
  //{path: 'partner-principal', component:PartnerPrincipalComponent}, 
  //{path: 'partner-home', component:PartnerHomeComponent},
  //{path: 'partner-beneficios', component:PartnerBeneficiosComponent}, 
  //{path: 'partner-recompensas', component:PartnerRecompensasComponent},
  //{path: 'partner-cuenta',component:PartnerMicuentaComponent},
  //{path: 'partner-register', component:PartnerRegistroComponent},  
  //{path: 'partner-carrito', component:PartnerCarritoComponent},  
  //{path: 'partner-finpedido',component:PartnerFinpedidoComponent}, 
  //{path: 'partner-finpedido-transferencia',component:PartnerFinpedidoTransferenciaComponent},
  //{path: 'partner-error-compra',component:PartnerErrorCompraComponent},
  //{path: 'partner-pasarela', component:PartnerPasarelaComponent},
  //{path: 'partner-clientes', component:PartnerClientesComponent}, 
  //{path: 'partner-ofertas-mes', component:PartnerOfertaMesComponent},
  //{path: 'partner-descuentos',component:PartnerDescuentosComponent},
  //{path: 'partner-mispedidos', component:PartnerMispedidosComponent}, 
  //{path: 'partner-detalle-descuentos',component:PartnerDetalleDescuentosComponent},
  //{path: 'partner-cotizador', component:CotizadorPartnerComponent},
  //{path: 'cliente-seguimiento-pedido/:contrato/:periodo/:ejercicio/:semaforo',component:ClienteSeguimientoPedidosComponent},
  //  {path: 'capacidad-almacen', component:PlaneadorCapacidadAlamacenComponent},
  // {path: 'traspasos-nacional',component:PlaneadorTraspasosNacionalComponent},
  //   {path: 'planeador-logistica',component:PlaneadorLogisticaComponent}, 
  //  {path: 'comprasPlaneador',component:PlaneadorComprasComponent},
  //{path: 'prospectacion', component:SearchProspectacionComponent},
  // {path: 'partner-ofertas', component:PartnerOfertasComponent}, 
  // {path: 'transitosGeneradosDetalle', component: TransitosGeneradosComponent},
  //{path: 'transitosGenerados', component: TransitosGeneradosEncabezadoComponent},
  //{ path: 'claves-sustitutas',component:PlaneadorClavesSustitutasComponent},
  // {path: 'transitos',component:TransitosComponent},
  //{path: 'transitos-indicadores',component:TransitosIndicadoresComponent},
  // {path: 'compras-excedente',component:PlaneadorComprasExcedenteComponent},
  //  {path: 'compras-transitos',component:TransitosComprasComponent},
  //{ path: 'retoTork', component: RetoTorkComponent},
  //  { path: 'retoTorkBitacoraInicial', component: RetoTorkBitacoraInicialComponent},
  //{ path: 'productos', component: CotizadorLineaComponent },
  //{ path: 'productos/:categoria', component: CotizadorSubLineaComponent },
  // { path: 'productos/:categoria/:grupo', component: CotizadorArticulosComponent },  
  // { path: 'productos/:categoria/:grupo/:productoNombre', component: DetalleArticuloComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes),],
  exports: [RouterModule]
})
export class AppRoutingModule { }